import React, { useState, useEffect, Fragment } from "react"
import MetaTags from 'react-meta-tags';
import { useSelector } from "react-redux";

import { Link, useHistory } from "react-router-dom"
import { Container, Row, Col, Button, Input, Label, Card, CardBody } from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

import moment from 'moment';
import { disposeComplete, disposeListComplete, getTreatmentDisposeList } from "../../crud/auth.crud"
import Util from "pages/Dashboard/Common/Util";
import Modal from "components/RopikCustom/Modal_v2";

import Loading from "pages/Custom/Loading";
import * as XLSX from 'xlsx';

const selectedClass = 'secondary-bg white-text border-none'
const unselectedClass = 'button-border secondary-text white-bg'

const WearingHistory = () => {
  const selector = useSelector(state => state)
  const history = useHistory()
  const companyData = selector.auth?.user?.member_group?.[0]?.company_group
  const companyId = companyData.id
  const newDate = new Date()
  
  // 드롭다운 map용
  const currentYear = newDate.getFullYear();
  const yearSelect = Array.from({ length: 4 }, (_, i) => currentYear - 3 + i);
  const monthSelect = [
    ...Array(12).keys()
  ].map(x => x + 1)

  const [dataList, setDataList] = useState([]);
  const [isLoading, setIsLoading] = useState({
    get: false,
    post: false
  });
  const [searchCondition, setSearchCondition] = useState({})
  const [page, setPage] = useState(1)
  const [listCount, setListCount] = useState(0)
  const [refresh, setRefresh] = useState(false)
  const [isListEnd, setIsListEnd] = useState(false)
  const [year, setYear] = useState(currentYear);
  const [month, setMonth] = useState('');
  const [selectedList, setSelectedList] = useState([])
  const [selectedItem, setSelectedItem] = useState(null)
  const [inputItem, setInputItem] = useState(null)
  const [modalShow, setModalShow] = useState({
    approval: false,
    batchProcessing: false
  })

  const changeInputCondition = (key, value) => {
    setInputItem(prev => ({...prev, [key]: value}))
  }

  const modalOpen = (key) => {
    setModalShow(prev => ({...prev, [key]: true}))
  }

  const modalClose = (key) => {
    setModalShow(prev => ({...prev, [key]: false}))
  }

  const changeLoadingState = (key, bool) => {
    setIsLoading(prev => ({...prev, [key]: bool}))
  }

  useEffect(() => {
    const scBody = document.getElementById("sc-body");
    if (!scBody) return;
    const handleScroll = () => {
      const scrollPosition = scBody.scrollTop;
      const scrollHeight = scBody.scrollHeight - scBody.clientHeight;
      if (scrollPosition >= scrollHeight - 1) {
        setPage(page + 1)
      }
    }
    scBody.addEventListener('scroll', handleScroll)

    return () => {
      scBody.removeEventListener('scroll', handleScroll)
    }
  }, [dataList])

  const getDataList = async () => {
    if (isLoading.get || isListEnd)
      return

    changeLoadingState('get', true)
    try {
      const params = {
        company_name: searchCondition.companyName || '',
        company_number: searchCondition.companyNumber || '',
        page: page,
        year: year,
        month: month,
      }
      const response = await getTreatmentDisposeList(params)
      setListCount(response.data?.count || 0)
      if (response.status === 200) {
        let content = response?.data?.results || [];
        const newList = [...dataList, ...content]
        if (page === 1) {
          setDataList(content)
        } else {
          setDataList(newList)
        }
        if (newList.length >= response.data.count) {
          setIsListEnd(true)
        }
      }
      changeLoadingState('get', false)
      setRefresh(false)
    } catch (error) {
      console.error(error);
      changeLoadingState('get', false)
      setRefresh(false)
    }
  }
  
  const changeDisposeState = async() => {
    if (isLoading.post)
      return

    changeLoadingState('post', true)
    try {
      const params = {
        id : selectedItem?.id,
        memo: inputItem?.memo || '',
        qty: inputItem?.qty || selectedItem?.qty
      }
      const response = await disposeComplete(params)
      if (response?.data?.result === 'success') {
        modalClose('approval')
        setSelectedItem(null)
        setSelectedList([])
        setPage(1)
        setIsListEnd(false)
      } else {
        alert(response?.data?.msg)
      }
      changeLoadingState('post', false)
    } catch (error) {
      console.error(error);
      changeLoadingState('post', false)
    }

  }
  
  const batchProcess = async() => {
    if (isLoading.post)
      return
    if (selectedList.length === 0) {
      alert('입고승인할 항목을 1개 이상 선택해주세요.')
    }
    changeLoadingState('post', true)
    try {
      const params = {
        ids : JSON.stringify(selectedList),
      }
      const response = await disposeListComplete(params)
      if (response?.data?.result === 'success') {
        modalClose('batchProcessing')
        setSelectedItem(null)
        setSelectedList([])
        setPage(1)
        setIsListEnd(false)
      } else {
        alert(response?.data?.msg)
      }
      changeLoadingState('post', false)
    } catch (error) {
      console.error(error)
      changeLoadingState('post', false)
    }
  }

  const changeSearchCondition = (key, value) => {
    setSearchCondition(prev => ({ ...prev, [key]: value }))
  }

  const excelDownload = async () => {
    const table = document.getElementById('excel-table');
    if (!table) return;

    const rows = table.querySelectorAll('tr');
    const data = [];

    for (let i = 0; i < rows.length; i++) {
      const cells = rows[i].querySelectorAll('td, th');
      const rowData = [];

      for (let j = 0; j < cells.length; j++) {
        rowData.push(cells[j].innerText);
      }

      data.push(rowData);
    }

    const ws = XLSX.utils.aoa_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    const wbout = XLSX.write(wb, {
      bookType: 'xlsx',
      type: 'array'
    });

    const blob = new Blob(
      [wbout],
      { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' }
    );

    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = `${'인계 목록'}.xlsx`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    URL.revokeObjectURL(url);
  }

  const checkList = (item) => {
    setSelectedList(prev => prev.includes(item.id) ? prev.filter(v => v !== item.id) : [...prev, item.id])
  }

  const onSearch = async () => {
    if (page === 1) {
      setRefresh(true)
    } else {
      setPage(1)
    }
    setIsListEnd(false)
  }

  useEffect(() => {
    if (refresh)
      getDataList()
  }, [refresh])

  useEffect(() => {
    if (!isListEnd)
      setRefresh(true)
  }, [page, isListEnd])

  const handleYearClick = (e) => {
    setYear(e.target.value)
    setIsListEnd(false)
    setMonth('')
    if (page === 1) {
      setRefresh(true)
    } else {
      setPage(1)
    }
  }

  const handleMonthClick = (e) => {
    setMonth(e.target.value)
    setIsListEnd(false)
    if (page === 1) {
      setRefresh(true)
    } else {
      setPage(1)
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>인계내역 / 웨이스트버스</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs maintitle="Home" title="관리대장" breadcrumbItem="인계내역" />

          <div className="d-flex w-100 gap-30">
            <div className="email-rightbar flex-grow-1">
              <Card>
                <CardBody className="padding-0">
                  <table className="input-table">
                    <tbody>
                      <tr>
                        <td className="col-10 padding-left-8 primary-bg white-text font-size-12">상호명</td>
                        <td className="col-20">
                          <input className="waver-input-box border-radius-0 w-100 margin-right-4" placeholder={'상호명을 입력하세요.'} value={searchCondition.companyName || ''} onChange={(e) => {
                            changeSearchCondition('companyName', e.target.value)
                          }} />
                        </td>
                        <td className="col-10 padding-left-8 primary-bg white-text font-size-12">사업자번호</td>
                        <td className="col-20">
                          <input className="waver-input-box border-radius-0 w-100 margin-right-4" placeholder={'사업자번호를 입력하세요.'} value={searchCondition.companyNumber || ''} onChange={(e) => {
                            changeSearchCondition('companyNumber', e.target.value)
                          }} />
                        </td>
                        <td className="col-10 padding-left-8 primary-bg white-text font-size-12"></td>
                        <td className="col-20"></td>
                      </tr>
                    </tbody>
                  </table>
                </CardBody>
              </Card>
            </div>
            <div className="d-flex flex-direction-column align-items-end">
              <button style={{ width: 143 }} type="button" className="custom-btn btn-dark-gradient border-radius-0 white-text border-none margin-right-0 margin-top-6" onClick={() => {
                onSearch()
              }}>
                검색
              </button>
            </div>
          </div>

          <div className="d-flex justify-content-between align-items-center mb-2">
            <div className="d-flex align-items-center">
              <select id="yearselect" name="yearselect" className='waver-select-box border-radius-0 margin-right-16' value={year} onChange={(e) => {
                handleYearClick(e)
              }}>
                {yearSelect && yearSelect.map((item, index) => {
                  return (
                    <option key={'year_select_' + index} value={item}>{item + "년"}</option>
                  )
                })}
              </select>
              <select id="monthselect" name="monthselect" className='waver-select-box border-radius-0 margin-right-16' value={month} onChange={(e) => {
                handleMonthClick(e)
              }}>
                <option value="">전체</option>
                {monthSelect && monthSelect.map((item, index) => {
                  return (
                    <option key={'month_select_' + index} value={item}>{item + "월"}</option>
                  )
                })}
              </select>
              <p className="mb-0 font-size-16"><span className="font-weight-bold">인계 목록</span> [ 건수 : {listCount}건 ]</p>
            </div>
            <div className="waver-pagination-btn-group" >
              <button style={{ width: 143 }} className="custom-btn success-bg border-radius-0 white-text border-none margin-right-8"
                onClick={() => {
                  excelDownload()
                }} >
                엑셀 다운로드
              </button>
              <button style={{ width: 143 }} className="custom-btn secondary-bg border-radius-0 white-text border-none margin-right-0"
                onClick={() => {
                  modalOpen('batchProcessing')
                }} >
                입고일괄처리
              </button>
            </div>
          </div>
          <Row>
            <Col xs="12">
              <div className="email-rightbar mb-3">

                <Card>
                  <CardBody style={{ padding: 0, borderRadius: 4, overflow: 'hidden' }}>
                    <div id={"sc-body"} style={{maxHeight: 660}} className="table-responsive">
                      <table id="excel-table" className="table table-hover table-centered table-nowrap mb-0 chart-table">
                        <thead className="chart-thead">
                          <tr>
                            <th scope="col">선택</th>
                            <th scope="col">운반업체명</th>
                            <th scope="col">차량번호</th>
                            <th scope="col">인계일시</th>
                            <th scope="col">인계량</th>
                            <th scope="col">입고처리</th>
                          </tr>
                        </thead>
                        <tbody className="chart-tbody">
                          {dataList.map((item, index) => {
                            return (
                              <tr key={'wearing_history_' + index}>
                                <td>
                                  <input className={`is-untouched is-pristine av-valid form-check-input ${item.state === 'Y' ? 'dashboard-check-disabled' : 'dashboard-check-abled'}`} type="checkbox" name="charge_report" checked={selectedList.includes(item?.id)} disabled={item.state === 'Y'} onChange={() => {
                                    checkList(item)
                                  }} />
                                </td>
                                <td>{item.company?.name}</td>
                                <td>{item.car?.number}</td>
                                <td>{moment(item.created_at).format('YYYY-MM-DD HH:mm:ss')}</td>
                                <td>{Util.setCommaPrice(item.qty)}</td>
                                <td className="click-not">
                                  <button style={{ width: 84, height: 29 }} type="button" className={`custom-btn border-radius-0 margin-right-4 font-size-15 line-height-1 ${item.state === 'Y' ? unselectedClass : selectedClass}`} onClick={(e) => {
                                    e.stopPropagation()
                                    if (item.state === 'I') {
                                      modalOpen('approval')
                                      setSelectedItem(item)
                                    }
                                  }}>
                                    {item.state === 'Y' ? '입고완료' : '입고승인'}
                                  </button>
                                </td>
                              </tr>
                            )
                          })}
                          {dataList.length === 0 &&
                            <tr>
                              <td scope="row" colSpan="14">데이터가 없습니다.</td>
                            </tr>
                          }

                        </tbody>
                      </table>
                    </div>
                  </CardBody>
                  {isLoading.get && <Loading />}
                </Card>

              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <Modal
        title={'인수 일괄 처리'}
        show={modalShow.batchProcessing}
        onHide={() => {
          modalClose('batchProcessing')
        }}
        size="md"
        bodyChildren={
          <Fragment>
            <p>인수 처리 되지 않은 인계 목록의 처리량이 일괄적으로 인수처리 됩니다.</p>
            <p>정말 인수 일괄 처리를 하시겠습니까?</p>
          </Fragment>
        }
        footerChildren={
        <div className="d-flex justify-content-end">
          <button style={{width: 'auto'}} type="button" className="waves-effect custom-btn active btn btn-dark-gradient btn-sm" onClick={() => {
            batchProcess()
          }}>
            확인
          </button>
          <button style={{width: 'auto'}} type="button" className="waves-effect custom-btn active btn btn-white-border btn-sm" onClick={() => {
            modalClose('batchProcessing')
          }}>
            취소
          </button>
        </div>
        }
      >
      </Modal>

      <Modal
        title={'인계량 확인'}
        show={modalShow.approval}
        onHide={() => {
          modalClose('approval')
          setSelectedItem(null)
        }}
        size="lg"
        bodyChildren={
          <Fragment>
            <table className="input-table">
              <tbody>
                <tr>
                  <td className="w-15 padding-left-8 primary-bg white-text font-size-12">사업자번호</td>
                  <td className="w-35">
                    {selectedItem?.dispose_company?.company_number}
                  </td>
                  <td className="w-15 padding-left-8 primary-bg white-text font-size-12">상호</td>
                  <td className="w-35">
                    {selectedItem?.dispose_company?.name}
                  </td>
                </tr>
                <tr>
                  <td className="w-15 padding-left-8 primary-bg white-text font-size-12">인계일시</td>
                  <td className="w-35">
                    {moment(selectedItem?.created_at).format('YYYY-MM-DD HH:mm:ss')}
                  </td>
                  <td className="w-15 padding-left-8 primary-bg white-text font-size-12">인계량</td>
                  <td className="w-35">
                    <input className='waver-input-box w-100 border-radius-0' value={inputItem?.qty || selectedItem?.qty} placeholder="인계량을 입력해 주세요." onChange={(e) => {
                      changeInputCondition('qty', e.target.value)
                    }} />
                  </td>                  
                </tr>
                <tr>
                  <td className="w-15 padding-left-8 primary-bg white-text">메모</td>
                  <td colSpan="3" className="w-85 pb-0">
                    <textarea className="waver-text-box w-100 font-size-12 border-radius-0" value={inputItem?.memo}
                    onChange={(e)=>{
                      changeInputCondition('memo', e.target.value);
                    }} />
                  </td>
                </tr>
              </tbody>
            </table>
          </Fragment>
        }
        footerChildren={
        <div className="d-flex justify-content-end w-100">
          <div className="d-flex">
            <button style={{width: 59, height: 27}} className="`custom-btn border-radius-0 margin-right-4 font-size-14 line-height-1 secondary-bg white-text border-none" onClick={() => {
              changeDisposeState()
            }}>{'확인'}</button>
            <button style={{width: 59, height: 27}} className="custom-btn border-radius-0 font-size-14 line-height-1 button-border secondary-text white-bg margin-right-0" onClick={() => {
              setSelectedItem(null)
              modalClose('approval')
            }}>취소</button>
          </div>
        </div>
        }
      />
    </React.Fragment>
  )
}

export default WearingHistory
